import React from 'react'
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Spin, Icon } from 'antd';

const loading = {
  display: 'flex',
  height: '100%',
  flexDirection: 'column',
  justifyContent: 'center',
  alignContent: 'center',
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    userIsLoading: state.userIsLoading,
    errorMessage: state.errorMessage
  }
}

class LoadingSpinner extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      needToLogout: false 
    }
  }

  componentWillUpdate(nextProps) {
    if (!nextProps.user.username) {
      this.setState({needToLogout:true})
    }
  }

  render () {
    let username = this.props.user.username
      if (this.state.needToLogout || this.props.needToLogout) {
        return (
          <Redirect to="/login" />
        )
      } else {
        return (
          <div style={loading}>
            <Spin/>
          </div>
        )
      }
    }      
  }

export default connect(mapStateToProps)(LoadingSpinner)


// WEBPACK FOOTER //
// ./src/views/Layout/Loading.jsx